import { memo } from 'react';
import ConditionalVisible from '../ConditionalVisible/ConditionalVisible.js';
import './ControlBar.scss';
import { jsx } from 'react/jsx-runtime';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@dtvgo/classnames';
import '../ConditionalVisible/ConditionalVisible.scss';

/* External */
function ControlBar(_ref) {
  var display = _ref.display,
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/jsx(ConditionalVisible, {
    className: "dtv-common-c-control-bar ".concat(className),
    visible: display,
    children: children
  });
}

// As long as the Control Bar is hidden, we can memoize as it should not be rerendered
var MemoizedControlBar = /*#__PURE__*/memo(ControlBar, function (prevProps, nextProps) {
  return nextProps.display === false && prevProps.display === nextProps.display;
});
ControlBar.defaultProps = {
  display: false,
  className: '',
  children: []
};

export { MemoizedControlBar as default };
//# sourceMappingURL=ControlBar.js.map
